import {
  DialogTrigger,
  LinkButton,
  Popover,
  PopoverContent,
} from "@certn/cascadia-react";
import { Trans } from "react-i18next";

export function WhatsThis({ children }: { children: React.ReactNode }) {
  return (
    <DialogTrigger>
      <LinkButton testID="" textStyle="form/body-secondary-link">
        <Trans>What's this?</Trans>
      </LinkButton>
      <Popover placement="top right">
        <PopoverContent>{children}</PopoverContent>
      </Popover>
    </DialogTrigger>
  );
}
